/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BetreuungsintensitaetInputs */

const de__field_betreuungsintensitaet = /** @type {(inputs: _Field_BetreuungsintensitaetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreueungsintensität`)
};

/**

* @param {_Field_BetreuungsintensitaetInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_betreuungsintensitaet = /** @type {((inputs?: _Field_BetreuungsintensitaetInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BetreuungsintensitaetInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_betreuungsintensitaet(inputs)
});